import React, { useEffect, useState } from "react";
import { formatDate } from "../../../../utils/utils";
import { Badge } from "react-bootstrap";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getSalesJourney } from "../../../../services/crm/salesJourney";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
const SearchJourney = ({ onSelectJourney }) => {
  const { reload } = useGlobalData();
  const [journeys, setJourneys] = useState([]);
  useEffect(() => {
    getSalesJourneyData();
  }, [reload]);
  return (
    <CustomDataTableSearch
      data={journeys}
      onRefreshData={() => {
        getSalesJourneyData();
      }}
      onSelectedData={(rowData, originalEvent) => {
        onSelectJourney(rowData);
      }}
      columns={[
        {
          field: "select",
          body: (rowData) => (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-label-success btn-sm btn-pill btn-bold"
                onClick={() => onSelectJourney(rowData)}
              >
                Select <i className="fas fa-angle-double-right"></i>
              </button>
            </React.Fragment>
          ),
        },
        {
          header: "Sales Journey ID",
          field: "ID",
          body: null,
          sortable: true,
        },
        {
          header: "Sales Journey Name",
          field: "title",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.title} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Sales Journey Status",
          field: "statusDesc",
          body: (rowData) => (
            <React.Fragment>
              <Badge
                variant={
                  rowData.statusID === 1
                    ? "warning"
                    : rowData.statusID === 2
                    ? "primary"
                    : rowData.statusID === 3
                    ? "success"
                    : rowData.statusID === 9
                    ? "danger"
                    : null
                }
              >
                {rowData.statusDesc}
              </Badge>
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Plan Start Date",
          field: "planStartDate",
          body: (rowData) => formatDate(rowData.planStartDate),
          sortable: true,
        },
        {
          header: "Plan End Date",
          field: "planEndDate",
          body: (rowData) => formatDate(rowData.planEndDate),
          sortable: true,
        },
      ]}
    />
  );
  async function getSalesJourneyData() {
    const response = await getSalesJourney();
    const { data } = response.data;
    setJourneys(data.salesJourney);
  }
};

export default SearchJourney;
